export const MAPPING_KEY_OPTIONS = [
  { text: 'Key Name', value: '' },
  { text: 'Client Name', value: 'clientName' },
  { text: 'Interest Rate', value: 'interestRate' },
  { text: 'Lock-in Period', value: 'lockInPeriod' },
  { text: 'Maturity Date', value: 'maturityDate' },
  { text: 'Early Redemption', value: 'earlyRedemption' },
  { text: 'Payout Frequency', value: 'payoutFrequency' },
  { text: 'Redemption Period', value: 'redemptionPeriod' },
  { text: 'Early Redemption Fee', value: 'earlyRedemptionFee' },
  { text: 'Redemption Notice Days', value: 'redemptionNoticeDays' },
  { text: 'Redemption Gate Percent', value: 'redemptionGatePercent' },
  { text: 'Asset Fee', value: 'assetFee' },
  { text: 'Hurdle Rate', value: 'hurdleRate' },
  { text: 'Carry Rate', value: 'carryRate' },
  { text: 'Reinvestment', value: 'reinvestment' },
  // Share-priced investments: filled from the investor's order, so the source is not used.
  { text: 'Investment Amount', value: 'investmentAmount' },
  { text: 'No. of Shares', value: 'numberOfShares' },
  { text: 'Price per Share', value: 'pricePerShare' },
  { text: 'Upfront Fees (amount)', value: 'upfrontFees' },
  { text: 'Upfront Fees (%)', value: 'upfrontFeesPercent' },
  { text: 'Final Investment Amount', value: 'finalInvestmentAmount' },
]

export const SOURCE_OPTIONS = [
  { text: 'Source Name', value: '' },
  { text: 'Opportunity', value: 'opportunity' },
  { text: 'Client', value: 'investor' },
  { text: 'Custom', value: 'investorOpportunityTerms' },
]

export const CUSTOM_KEY_OPTIONS = [
  { text: 'Key Name', value: '' },
  { text: 'Interest Rate', value: 'interest_rate' },
  { text: 'Payout Frequency', value: 'payout_frequency' },
  { text: 'Portfolio Service Fee (%)', value: 'portfolio_service_fee' },
  { text: 'Hurdle Rate (%)', value: 'hurdle_rate' },
  { text: 'Carry Rate (%)', value: 'carry_rate' },
  { text: 'Reinvestment Option', value: 'reinvestment_option_enabled' },
  { text: 'Dividend per unit (USD)', value: 'dividend_per_unit' },
]

export const BOOLEAN_CUSTOM_FIELD_OPTIONS = [
  { text: 'Select', value: '' },
  { text: 'Yes', value: 'true' },
  { text: 'No', value: 'false' },
]

const percentageRateRule = {
  type: 'number' as const,
  min: 0,
  max: 100,
}

export const FIELD_VALIDATION_RULES: Record<
  string,
  {
    type?: 'string' | 'number' | 'boolean'
    min?: number
    max?: number
  }
> = {
  interest_rate: { type: 'number', min: 0, max: 100 },
  payout_frequency: { type: 'string' },
  portfolio_service_fee: percentageRateRule,
  hurdle_rate: percentageRateRule,
  carry_rate: percentageRateRule,
  reinvestment_option_enabled: { type: 'boolean' },
  dividend_per_unit: { type: 'number', min: 0 },
}

export const hasConfiguredFieldValue = (value: unknown): boolean =>
  value !== undefined && value !== null && value !== ''

export const validateCustomFields = (
  fields: Record<string, unknown>,
  formatLabel: (key: string) => string,
): Record<string, string> => {
  const errors: Record<string, string> = {}

  for (const key in fields) {
    const value = fields[key]
    if (!hasConfiguredFieldValue(value)) {
      continue
    }

    const rule = FIELD_VALIDATION_RULES[key]
    if (!rule) {
      continue
    }

    if (rule.type === 'number' && isNaN(Number(value))) {
      errors[key] = `${formatLabel(key)} must be a valid number`
      continue
    }

    if (
      rule.type === 'boolean' &&
      value !== 'true' &&
      value !== 'false' &&
      value !== true &&
      value !== false
    ) {
      errors[key] = `${formatLabel(key)} must be Yes or No`
      continue
    }

    if (rule.min !== undefined && Number(value) < rule.min) {
      errors[key] = `${formatLabel(key)} must be >= ${rule.min}`
    }
    if (rule.max !== undefined && Number(value) > rule.max) {
      errors[key] = `${formatLabel(key)} must be <= ${rule.max}`
    }
  }

  return errors
}

export const OPPORTUNITY_FEE_METADATA_KEYS = [
  'portfolio_service_fee',
  'hurdle_rate',
  'carry_rate',
] as const

export const formatOpportunityFeeLabel = (key: string): string => {
  const labels: Record<string, string> = {
    portfolio_service_fee: 'Portfolio Service Fee',
    hurdle_rate: 'Hurdle Rate',
    carry_rate: 'Carry Rate',
  }
  return labels[key] ?? key
}
